import React, { Component } from "react";
import { Form, Input, DatePicker, AutoComplete, Spin } from "antd";
import PhoneInput from "react-phone-input-2";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";

import { InputNumber } from "../../../../components/common/input-number";
import { Dropdown } from "../../../../components/common/dropdown";
import { CarStatusType } from "../../vehicle/car-status-type/car-status-type";
import { HasEnglish } from "./has-english/has-english";
import { Certificate } from "./certificate/certificate";
import { DriverAccountStatus } from "./driver-account-status/driver-account-status";
import { apiUser } from "../../../../api/api-users";
import { checkDriverType } from "../driver-list/driver-event";

const { TextArea } = Input;
const { Option } = AutoComplete;
const antIcon = <LoadingOutlined style={{ fontSize: 22 }} spin />;

const dataField = [
  {
    title: "* Ngày hết hạn bằng lái::",
    title2: "Ngày hết hạn bằng lái::",
    fieldName: "license_exprire",
  },
  {
    title: "* Trạng thái của tài xế::",
    fieldName: "driver_status",
  },
  {
    title: "* Trạng thái tài khoản::",
    fieldName: "driver_account_status",
  },
  {
    title: "* Tiếng Anh::",
    title2: "Tiếng Anh::",
    fieldName: "has_english",
  },
  {
    title: "* Chứng chỉ DDT::",
    title2: "Chứng chỉ DDT::",
    fieldName: "certificate",
  },
  {
    title: "Ghi chú::",
    fieldName: "note",
  },
  {
    title: "* Điều hành khối::",
    title2: "Điều hành khối::",
    fieldName: "manager",
  },
  {
    title: "* Tên đăng nhập::",
    fieldName: "employee_id",
  },
  {
    title: "* Password::",
    fieldName: "password",
  },
];

export class RightForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      in_current_journey_diary: false,
      in_current_contract: false,
      activeEye: false,
      showPassword: true,
      unit_operators: [],
      driverStatus: 1,
    };
  }

  checkEditPass = (e) => {
    this.props.checkEditPass(e.target.value);
    this.setState({
      activeEye: true,
    });
  };

  showPassword = () => {
    this.setState({ showPassword: true });
  };

  hidePassword = () => {
    this.setState({ showPassword: false });
  };

  onSearch = (data) => {
    var self = this;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.page = 1;

    this.currentValue = data;
    this.onChangeFormValues({
      name: data.toUpperCase(),
    });
    if (!data) {
      this.setState({
        unit_operators: [],
      });
      return;
    }

    async function searchData() {
      let func = apiUser.getUsers;
      let filters = {
        branch: {
          code: null,
        },
        code: null,
        created_by: {
          name: null,
        },
        department: {
          id: 2,
        },
        name: `%${data
          .trim()
          .replace(/(\r\n|\n|\r)/gm, " ")
          .replace(/%/gi, "\\%")}%`,
        active: true,
      };
      try {
        const result = await func(filters, 1);
        if (result.status === "success") {
          self.totalPage = result.data.totalPages;
          if (self.currentValue !== data) {
            return;
          }
          self.setState({
            unit_operators: result.data.content.map((suggestion) => {
              return {
                ...suggestion,
                value: suggestion.name,
              };
            }),
          });
        }
      } catch (error) {}
    }

    this.timeout = setTimeout(searchData, 300);
  };

  onSelect = (item) => {
    const { data } = item;
    this.currentValue = data.name;
    this.page = 1;
    this.totalPage = 1;
    this.setState({ unit_operators: [data], unit_operator_id: data.id });
    let values = {
      operation_admin: data.name,
    };
    this.onChangeFormValues(values);
  };

  onChangeFormValues = (values) => {
    const { onChangeFormValues } = this.props;
    onChangeFormValues({ ...values });
  };

  loadMoreFunc = async () => {
    let func = apiUser.getUsers;
    const data = this.currentValue;
    let filters = {
      branch: {
        code: null,
      },
      code: null,
      created_by: {
        name: null,
      },
      department: {
        id: 2,
      },
      name: `%${data
        .trim()
        .replace(/(\r\n|\n|\r)/gm, " ")
        .replace(/%/gi, "\\%")}%`,
      active: true,
    };
    try {
      this.setState({ isLoadMore: true });
      const result = await func(filters, this.page);

      if (result.status === "success") {
        this.totalPage = result.data.totalPages;
        this.setState(
          {
            unit_operators: this.state.unit_operators.concat(
              result.data.content.map((suggestion) => {
                return {
                  ...suggestion,
                  value: suggestion.name,
                };
              })
            ),
          },
          () => this.setState({ isLoadMore: false })
        );
      } else {
        this.setState({ isLoadMore: false });
      }
    } catch (error) {
      this.setState({ isLoadMore: false });
    }
  };

  suggestionRender = (data) => {
    let loadMore = false;
    loadMore = this.totalPage > this.page;

    const { isLoadMore } = this.state;

    return (
      <>
        {data.map((item) => {
          return (
            <Option
              data={item}
              style={styles.selectOptoption}
              key={item.id}
              value={item.value}
            >
              <div style={styles.container}>
                <div
                  style={{ overfloWrap: "break-word", whiteSpace: "pre-wrap" }}
                >
                  {item.name} - {item.code}
                </div>
              </div>
            </Option>
          );
        })}
        {data.length > 0 && loadMore && !isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div
              onClick={() => {
                this.page++;
                this.loadMoreFunc();
              }}
              style={styles.loadmore}
            >
              Loadmore
            </div>
          </Option>
        )}
        {isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div style={styles.loadmoreLoading}>
              <Spin indicator={antIcon} />
            </div>
          </Option>
        )}
      </>
    );
  };

  onChangeName = (data) => {
    this.onChangeFormValues({
      name: data.toUpperCase(),
    });
  };

  render() {
    const { editable, typeOption, customerResource, editPage } = this.props;
    const {
      in_current_journey_diary,
      in_current_contract,
      activeEye,
      showPassword,
      unit_operators,
      driverStatus,
    } = this.state;

    return (
      <>
        {dataField.map((field) => {
          return (
            <Form.Item
              className={
                field.fieldName === "note"
                  ? "alignText right-form"
                  : customerResource &&
                    (field.fieldName === "license_exprire" ||
                      field.fieldName === "has_english" ||
                      field.fieldName === "certificate" ||
                      field.fieldName === "manager")
                  ? "requireField right-form"
                  : " right-form"
              }
              wrapperCol={15}
              key={field.fieldName}
              label={
                customerResource &&
                (field.fieldName === "license_exprire" ||
                  field.fieldName === "has_english" ||
                  field.fieldName === "certificate" ||
                  field.fieldName === "manager")
                  ? field.title2
                  : field.title
              }
              rules={
                field.fieldName === "license_exprire" ||
                field.fieldName === "manager"
                  ? [checkDriverType(field.title)]
                  : //     field.fieldName === 'license_exprire' ? [{
                    //     required: true,
                    //     message: `Vui lòng chọn Ngày hết hạn bằng lái!`,
                    // }]
                    // : field.fieldName === 'manager' ? [{
                    //     required: true,
                    //     message: `Vui lòng chọn Điều hành khối!`,
                    // }]
                    null
              }
              name={field.fieldName}
            >
              {field.fieldName === "license_exprire" ? (
                <DatePicker
                  disabled={!editable}
                  // inputReadOnly
                  dropdownClassName="date-picker-dropdown-top"
                  getPopupContainer={(node) => {
                    if (node) {
                      return node.parentNode;
                    }
                    return document.body;
                  }}
                  format="DD/MM/YYYY"
                  className="dropdown-full"
                />
              ) : field.fieldName === "driver_status" ? (
                <CarStatusType
                  disabled={!editable}
                  typeOption={typeOption}
                  in_current_contract={in_current_contract}
                  in_current_journey_diary={in_current_journey_diary}
                  status={driverStatus}
                  onChangeFormValues={this.onChangeFormValues}
                />
              ) : field.fieldName === "has_english" ? (
                <HasEnglish disabled={!editable} typeOption={typeOption} />
              ) : field.fieldName === "driver_account_status" ? (
                <DriverAccountStatus
                  disabled={!editable}
                  typeOption={typeOption}
                />
              ) : field.fieldName === "certificate" ? (
                <Certificate disabled={!editable} typeOption={typeOption} />
              ) : field.fieldName === "note" ? (
                <TextArea disabled={!editable} rows={3} />
              ) : field.fieldName === "manager" ? (
                <AutoComplete
                  className="unit-operator"
                  placeholder="Chọn admin điều hành"
                  disabled={!editable}
                  getPopupContainer={(node) => {
                    if (node) {
                      return node.parentNode;
                    }
                    return document.body;
                  }}
                  ref={(ref) => (this.auto = ref)}
                  defaultActiveFirstOption={false}
                  onSearch={(data) => this.onSearch(data)}
                  onSelect={(data, option) => this.onSelect(option)}
                >
                  {this.suggestionRender(unit_operators)}
                </AutoComplete>
              ) : (
                <Input
                  className={
                    field.fieldName === "password" && showPassword
                      ? "text-security"
                      : ""
                  }
                  onChange={
                    field.fieldName === "password" ? this.checkEditPass : null
                  }
                  disabled={
                    !editable ||
                    field.fieldName === "employee_id" ||
                    (field.fieldName === "password" &&
                      typeOption === "create_new")
                  }
                />
              )}
            </Form.Item>
          );
        })}
        <span
          className={
            typeOption !== "edit" || !activeEye
              ? "block-click pass-visible"
              : "pass-visible"
          }
        >
          {!showPassword && <EyeOutlined onClick={this.showPassword} />}
          {showPassword && <EyeInvisibleOutlined onClick={this.hidePassword} />}
        </span>
      </>
    );
  }
}

export const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: 35,
  },
  contract_contained: {
    fontSize: "10px",
    color: "#f4bc2b",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
  icon: {
    fontSize: "0.9em",
    marginRight: 3,
    color: "#f4bc2b",
  },
  mainTitle: {
    fontSize: "0.93em",
    color: "#000",
    fontWeight: "500",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    //lineHeight: '10px'
  },

  selectOptoption: {
    borderBottom: "0.3px solid #d9d9d9",
    position: "relative",
  },
  loadmore: {
    color: "#3a7be2",
    position: "absolute",
    bottom: 0,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    padding: "0px 10px",
    zIndex: 9999,
    marginBottom: "5px",
  },
  loadmoreOption: {
    padding: "0px 4px",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
  loadmoreLoading: {
    display: "flex",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "0px 10px",
    marginBottom: "5px",
    zIndex: 9999,
  },
};
